import React, { useContext, useMemo } from 'react';
import Context from '../MainProvider/context';
import OperationsSession from '../../Operations/OperationsSession';
import SessionContext from './context';
import DashboardSession from '../../Dashboard/DashboardSession';

const SessionProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { user } = useContext(Context);
  const operations = new OperationsSession(user);
  const dashboard = new DashboardSession();

  const value = useMemo(() => ({ operations, dashboard }), [operations, dashboard]);

  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
};

export default SessionProvider;
